<template lang="pug">
  section.bloco-texto.clearfix
    figure.imagem
      img(href="#", :src="imagem")
    .texto
      titulo.-withbar: slot(name="titulo") {{ titulo }}
      p.paragrafo: slot(name="texto") {{ texto }}
      router-link.more(:to="{ name: 'Institucional', params: { slug: rota } }"): small Ver tudo
</template>

<style lang="scss">
  .bloco-texto {
    margin: 40px 0;

    .imagem {
      position: relative;
      display: none;
      margin-bottom: 15px;
      > img { width: 100%; }
      @include media(">phone") { width: 250px }
    }

    .texto {
      > .title { margin-bottom: 15px }
      > .more { float: right }
      > .more:hover { color: $color-green-dark; text-decoration: underline; }
    }

    &.-leftalign {
      @include media(">=tablet") {
        .imagem { float: left }
        .texto { padding-left: 280px }
      }
    }

    &.-rightalign {
      @include media(">=tablet") {
        .imagem { float: right }
        .texto { padding-right: 280px }
      }
    }

    @include media(">=tablet") {
      .imagem { display: block }
    }

    @include media(">=desktop") {
      .texto {
        > .paragrafo { margin-left: 15px }
      }
    }
  }
</style>

<script>
import Titulo from 'COMPONENTS/ElementTitle'
export default {
  name: 'bloco-texto',
  props: ['imagem', 'titulo', 'texto', 'rota'],
  components: { Titulo }
}
</script>



// WEBPACK FOOTER //
// BlocoTexto.vue?5e389a49